if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 1024px)');
        this.header = document.querySelector('.header-wrapper');
        this.footer = document.querySelector('.tw-vo-footer');
        this.elements = {
          localeInput: this.querySelector('input[name="locale_code"]'),
          countryInput: this.querySelector('input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          overlay: this.querySelector('.country-selector__overlay'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
          localizationPopup: this.querySelector('.localization-popup'),
          closePopupButton: this.querySelector('#closePopup')
        };
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleOverlayClick = this.hidePanel.bind(this);
        this.overlayContainer = this.elements.overlay?.parentElement || null;
        this.isFooterLocalization = Boolean(this.footer && this.footer.contains(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        // this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        if (this.elements.overlay) {
          this.elements.overlay.addEventListener('click', this.handleOverlayClick);
        }

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }
        if (this.footer && this.footer.contains(this.elements.localizationPopup)) {
          this.footer.parentElement.insertBefore(this.elements.localizationPopup, this.footer.nextSibling);
        }
        if (this.elements.localizationPopup) {
          this.updateLocalization();
          document.addEventListener('click', (event) => {
            if (event.target.closest?.('[data-vo-newsletter-popup-dialog]')) return;

            if (
              !this.elements.localizationPopup.contains(event.target) &&
              !this.elements.closePopupButton?.contains(event.target)
            ) {
              this.hidePopup();
            }
          });
        }
        if (this.elements.closePopupButton) {
          this.elements.closePopupButton.addEventListener('click', this.hidePopup.bind(this));
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));

        // When the close (X) button inside a language-picker drawer is clicked,
        // also close the whole country-selector panel.
        this.querySelectorAll('dialog .js-po-modal-close').forEach((btn) => {
          btn.addEventListener('click', () => this.hidePanel());
        });
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);

        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }

        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';

        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer')?.classList.remove('country-selector-open');
        document.removeEventListener('click', this.handleDocumentClick);
        this.elements.overlay?.classList.remove('is-visible');
        if (this.isFooterLocalization) {
          document.body.classList.remove('vo-country-selector-footer-open');
        }

        if (this.elements.overlay && this.overlayContainer && this.elements.overlay.parentElement !== this.overlayContainer) {
          this.overlayContainer.appendChild(this.elements.overlay);
        }

        if (this.header) {
          this.header.preventHide = false;
        }
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        if (event.currentTarget.dataset.external === 'true') return;
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.countryInput.value = event.currentTarget.dataset.country;
        this.elements.localeInput.value = event.currentTarget.dataset.locale;

        
        // const userConfirmed = confirm('Are you sure you want to submit the form?');
        // if (userConfirmed && form) {
        //   form.submit();
        // }

        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();

        const wasHidden = this.elements.panel.hasAttribute('hidden');
        this.elements.panel.toggleAttribute('hidden');

        if (wasHidden) {
          requestAnimationFrame(() => {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
          });
          document.addEventListener('click', this.handleDocumentClick);
          if (this.elements.overlay) {
            if (this.elements.overlay.parentElement !== document.body) {
              document.body.appendChild(this.elements.overlay);
            }
            this.elements.overlay.classList.add('is-visible');
          }
          if (this.isFooterLocalization) {
            document.body.classList.add('vo-country-selector-footer-open');
          }
        } else {
          document.body.style.overflow = '';
          document.documentElement.style.overflow = '';
          document.removeEventListener('click', this.handleDocumentClick);
          this.elements.overlay?.classList.remove('is-visible');
          if (this.isFooterLocalization) {
            document.body.classList.remove('vo-country-selector-footer-open');
          }
        }

        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );

        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }

        if (this.hasAttribute('data-prevent-hide') && this.header) {
          this.header.preventHide = true;
        }

        document.querySelector('.menu-drawer')?.classList.add('country-selector-open');

        if (this.footer && this.footer.contains(this.elements.panel)) {
          this.footer.parentElement.insertBefore(this.elements.panel, this.footer.nextSibling);
        }
      }

      handleDocumentClick(event) {
        if (!this.elements.panel.contains(event.target) && !this.elements.button.contains(event.target)) {
          this.hidePanel();
        }
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }


      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }

      hidePopup() {
        this.elements.localizationPopup?.setAttribute('hidden', true);
      }

      showPopup() {
        this.elements.localizationPopup?.removeAttribute('hidden');
      }

      updateLocalization() {
        if (sessionStorage.getItem('localizationUpdated')) return;

        fetch(
          window.Shopify.routes.root
          + 'browsing_context_suggestions.json'
          + '?country[enabled]=true'
          + '&language[enabled]=true'
        )
          .then(response => response.json())
          .then(data => {
            const detectedCountry = data.detected_values.country.name;
            const countryIsoCode = data.detected_values.country.handle.toLowerCase();
            const detectedLocale = data.suggestions[0].parts.language.handle;
            const userLocation = this.elements.localizationPopup.querySelector('.userLocation');
            const selectedLocation = this.elements.localizationPopup.querySelector('.selectedLocation');

            const popupLink = userLocation.querySelector('a');
            popupLink.setAttribute('id', countryIsoCode);

            if (selectedLocation.querySelector('a').id != popupLink.id) {
              popupLink.setAttribute('data-locale', detectedLocale);
              popupLink.setAttribute('data-country', countryIsoCode);

              const flagContainer = userLocation.querySelector('.country-flags-container');
              
              if (flagContainer) {
                const allFlagWrappers = flagContainer.querySelectorAll('.flag-wrapper');
                allFlagWrappers.forEach(wrapper => {
                  wrapper.style.display = 'none';
                });
                
                const targetFlagWrapper = flagContainer.querySelector(`.flag-wrapper[data-country="${countryIsoCode}"]`);
                if (targetFlagWrapper) {
                  targetFlagWrapper.style.display = 'block';
                } else {
                  console.warn(`Flag not found for country: ${countryIsoCode}`);
                }
              }

              const userCountryNames = document.querySelectorAll('.userCountryName');
              userCountryNames.forEach((userCountryName) => {
                userCountryName.textContent = detectedCountry;
              });
              this.showPopup();
              this.elements.localizationPopup.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
              sessionStorage.setItem('localizationUpdated', 'true');
            }
          })
          .catch(error => {
            console.error('Error fetching data:', error);
          });
      }

    }
  );
}
